import { SENDTOBANK } from './Constants';

export const sendToBankEmail = (status) => {
	return {
		type: SENDTOBANK,
		payload: status
	};
};
